import { getFullName } from './fullname.util'

type ProviderNameLike =
  | {
      first_name?: string
      middle_name?: string
      last_name?: string
      work_role?: string | null
      provider_id?: string
    }
  | null
  | undefined

export function isHygienistWorkRole(workRole?: string | null): boolean {
  if (!workRole) return false
  const normalized = workRole.trim().toLowerCase()
  return normalized.includes('hygienist')
}

/**
 * Formats a clinician name using work_role when available.
 * Hygienists: plain name. Other clinical roles: "Dr. {name}".
 */
export function formatClinicianDisplayName(
  provider: ProviderNameLike,
  options?: {
    fallback?: string
    /** Force hygienist (no Dr.) or provider (Dr.) style when work_role is missing. */
    preferStyle?: 'provider' | 'hygienist'
  },
): string {
  const fallback = options?.fallback ?? '-'
  if (!provider) {
    return fallback
  }

  const name = getFullName({
    first_name: provider.first_name ?? '',
    middle_name: provider.middle_name,
    last_name: provider.last_name ?? '',
  }).trim()

  if (!name) {
    return fallback
  }

  const asHygienist =
    options?.preferStyle === 'hygienist' ||
    (options?.preferStyle !== 'provider' &&
      isHygienistWorkRole(provider.work_role))

  if (asHygienist) {
    return name.replace(/^dr\.?\s+/i, '')
  }

  if (/^dr\.?\s/i.test(name)) {
    return name
  }

  return `Dr. ${name}`
}

export function formatProviderDisplayName(
  provider: ProviderNameLike,
  fallback = '-',
): string {
  return formatClinicianDisplayName(provider, { fallback })
}
